<template>
  <div class="input-group-card">
    <div class="input-container" >
      <b-card
        class="ngbr-input-group"
      >
        <b-card-header header-tag="div" class="p-1" role="tab">
          <h3 v-b-toggle="`toggle-${title}`">{{ title }}</h3>
        </b-card-header>
        <b-collapse :id="`toggle-${title}`" visible role="tabpanel" >
          <div v-for="input in inputGroup" :key="input.key">
            <NHBRInput
              v-if="isAllDependencyFullfilled(input.dependency)"
              :value="formInputs[input.key]"
              :inputKey="input.key"
              :label="input.label"
              :helpText="createHelpText(input.validation, input.validationText)"
              :inputType="input.type"
              :getValueFromBackend="!!input.get_value_from_backend"
              :isRecommendedField="!!input.recommended"
              :isValidField="input.validation !== null ? isValidFields(input.key, formInputs[input.key], input.validation) : true"
            />
          </div>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
import NHBRInput from '@/components/NHBRInput.vue'
import { isAllDependencyFullfilled } from '@/utils/dependencyUtil.js'
import { createHelpText } from "@/utils/validationUtil"
import { isValid, isLaborValid } from "@/utils/validationUtil"
import { mapState } from 'vuex'

export default {
  name: 'input-group-card',
  components: {
    NHBRInput
  },
  data() {
    return {
      validFields: {}
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    inputGroup: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState(['formInputs']),
  },
  methods: {
    isAllDependencyFullfilled(dependency) {
      return isAllDependencyFullfilled(dependency, this.formInputs)
    },
    isValidFields(inputKey, value, validation) {
      const isThisFieldValid = validation === 'labor' ? isLaborValid(value) : isValid(value, validation, this.formInputs)
      let stateToEmit = isThisFieldValid

      if(typeof stateToEmit === 'object' && stateToEmit !== null){
        stateToEmit = Object.values(stateToEmit).every((elem) => elem)
      }

      this.$emit('onValidStateChanged', {
        key: inputKey,
        isValid: stateToEmit
      })

      return isThisFieldValid
    },
    createHelpText(validation, validationText) {
      return createHelpText(validation, validationText)
    },
  },
}
</script>

<style scoped>
/*** Component Style ***/
.input-group-card {
  position: relative;
}

.input-container {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.ngbr-input-group {
  width: 700px;
  margin-bottom: 24px;
}

h3 {
  cursor: pointer;
}

.card-header {
  border: none;
}
</style>
